import React, { Component } from 'react';
import { Row, Col, Popover, OverlayTrigger } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Footer from '../Index/Footer';

import { CustomCard } from "../../../components/Card/CustomCard";
import { Guardar } from "../../../funciones/ContactoFunction";

class Contacto extends Component {
    state = {
        button: {
            icon: "fa fa-send",
            text: "Enviar"
        },
        nombre:  { text:"", status: "" },
        tlf:  { text:"", status: "" },
        email:  { text:"", status: "" },
        mess:  { text:"", status: "" },
        cantErrores: "",
    }

    constructor (props) {
        super (props);
        this.scrollIni();
    }

    scrollIni = () => {
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]:{
                text:(event.target.value).toUpperCase(),
                status: "",
            }
        });
    };

    enviar = (campos) => (e) => {
        this.setState({
            button: {
                icon: "fa fa-spinner fa-spin",
                text: "Espera"
            }
        }, () => {
            Guardar(campos, (resp) => {
                let mensaje = resp[1];
                let errores = resp[2];
                let nameErrores = resp[3]
                let contentErr = [];

                let erroresList = (
                    <Popover bsSize="large" title={<div className="fuente-monserrat">Errores Encontrados</div>} id="erroresList">
                        {contentErr}
                    </Popover>
                )

                let mensajeToast = (mensaje) => {
                    this.setState({
                        button: {
                            icon: "fa fa-send",
                            text: "Enviar"
                        }
                    }, () => {
                        toast[mensaje.status](<div className="fuente-monserrat">{mensaje.mensaje}</div>,{autoClose: 4000});
                    })
                }

                for (let i in nameErrores) {
                    if (nameErrores[i] !== "") contentErr.push(
                        <div key = {i} className="text-danger fuente-monserrat" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
                    )
                }

                if (errores === 0) {
                    this.setState({
                        button: {
                            icon: "fa fa-send",
                            text: "Enviar"
                        },
                        nombre:  { text:"", status: "" },
                        tlf:  { text:"", status: "" },
                        email:  { text:"", status: "" },
                        mess:  { text:"", status: "" },
                        cantErrores:""
                    })
                }

                if (mensaje[0].status === "error" && errores !== 0) this.setState ({
                    button: {
                        icon: "fa fa-send",
                        text: "Enviar"
                    },
                    cantErrores: <div style={{paddingTop:10}} className="fuente-monserrat">
                                    Se han encontrado {errores} error(es). Haz click <span>
                                    <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                        <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                                    </OverlayTrigger></span> para verlos
                                </div>
                })

                mensajeToast(mensaje[0]);
            })
        })
    }

    enterTab = (next) => (e) => {if (e.which === 13) document.getElementById(next).focus();}

    contenido = () => {
        let { nombre, tlf, email, mess, cantErrores } = this.state;

        const campos = { nombre, tlf, email, mess };

        return(
            <Row>
                <Col md={6}>
                    <Col md={12}>
                        <div className={nombre.status}>
                            <input type="text" className="form-control" maxLength={191} value={nombre.text} onChange={this.cambiaValor("nombre")} onKeyPress={this.enterTab("tlf")} placeholder="Ingresa tu nombre"/>
                        </div>
                    </Col>
                    <Col md={12} className="custom-mt-10">
                        <div className={tlf.status}>
                            <input type="text" className="form-control" maxLength={191} value={tlf.text} onChange={this.cambiaValor("tlf")} onKeyPress={this.enterTab("email")} id="tlf" placeholder="Ingresa tu teléfono"/>
                        </div>
                    </Col>
                    <Col md={12} className="custom-mt-10">
                        <div className={email.status}>
                            <input type="text" className="form-control" maxLength={191} value={email.text} onChange={this.cambiaValor("email")} onKeyPress={this.enterTab("mensaje")} id="email" placeholder="Ingresa tu correo"/>
                        </div>
                    </Col>
                    <Col md={12} className="custom-mt-10">
                        <div className={mess.status}>
                            <textarea className="form-control" maxLength={191} id="mensaje" value={mess.text} onChange={this.cambiaValor("mess")} onKeyPress={this.enterTab("enviar")} placeholder="Ingresa tu mensaje"></textarea>
                        </div>
                    </Col>
                </Col>
                <Col md={6}>
                    <div className="fuente-monserrat" style={{fontSize: 12}}><i className="fa fa-university"></i> | Instituto Universitario de Diseño Las Mercedes</div>
                    <div className="fuente-monserrat custom-mt-10" style={{fontSize: 12}}><i className="fa fa-map-marker"></i> | Avenida Río de Janeiro cruce con Calle Roraima, Chuao, Caracas</div>
                    <div className="fuente-monserrat custom-mt-10" style={{fontSize: 12}}><i className="fa fa-phone"></i> | Teléfonos: (0212) 9939139 | 9910710 | 9930983</div>
                    <div className="fuente-monserrat custom-mt-10" style={{fontSize: 12}}><i className="fa fa-envelope-o"></i> | E-mail: info@iudlm.edu.ve</div>
                    <div className="fuente-monserrat custom-mt-10" style={{fontSize: 12, marginBottom: 10}}><i className="fa fa-clock-o"></i> | Horario: Lunes a viernes de 7:00 am a 4:30 pm</div>
                </Col>
                <Col md={12}>
                    <Col md={3} className="custom-mt-10">
                        <button className="btn btn-danger fuente-monserrat" onClick={this.enviar(campos)} id="enviar" style={{borderWidth: 1, borderColor:"#a80012", backgroundColor:"#a80012", color:"#FFF"}} title="Enviar un mensaje a Contactos">
                            <i className={this.state.button.icon}></i> {this.state.button.text}
                        </button>
                    </Col>
                    <Col md ={9} className="custom-mt-10" align="right"><div className="text-danger">{ cantErrores }</div></Col>
                </Col>
            </Row>
        )
    }

    render() {
        return(
            <React.Fragment>            
                <div className="login-content">
                    <div className="wrapper2">
                        <div className="wave one"></div>
                        <div className="wave dos"></div>
                        <div className="wave tres"></div>
                        <div className="wave cuatro"></div>
                    </div>
                    <Row>
                        <Col md={2}></Col>
                        <Col md={8}>
                            <CustomCard
                                title={<div><i className="fa fa-user-circle-o"></i> Contacto</div>}
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </Col>
                        <Col md={2}></Col>
                    </Row>
                </div>
                <ToastContainer
                    position="bottom-right"
                    autoClose={3000}/>
            </React.Fragment>
        );
    }
}
 
export default Contacto;


// WEBPACK FOOTER //
// ./src/site/Componentes/Contacto/Contacto.jsx